var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckboxIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "none",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#23A994"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.96572 12.8355C6.85997 12.7298 6.80056 12.5863 6.80056 12.4368C6.80056 12.2872 6.85997 12.1438 6.96572 12.0381C7.07147 11.9323 7.21489 11.8729 7.36444 11.8729C7.51399 11.8729 7.65742 11.9323 7.76317 12.0381L10.5004 14.7753L16.3934 8.88227C16.4457 8.82991 16.5079 8.78837 16.5763 8.76004C16.6447 8.7317 16.7181 8.71711 16.7921 8.71711C16.8662 8.71711 16.9395 8.7317 17.0079 8.76004C17.0763 8.78838 17.1385 8.82991 17.1908 8.88227C17.2432 8.93463 17.2847 8.99679 17.3131 9.06521C17.3414 9.13362 17.356 9.20695 17.356 9.281C17.356 9.35505 17.3414 9.42837 17.3131 9.49678C17.2847 9.5652 17.2432 9.62736 17.1908 9.67972L11.0021 15.8685C10.9588 15.9433 10.8989 16.0072 10.827 16.0552C10.7551 16.1033 10.6731 16.1341 10.5873 16.1455C10.5016 16.1568 10.4144 16.1483 10.3325 16.1205C10.2506 16.0928 10.1761 16.0467 10.1149 15.9856L6.96572 12.8355Z",
    fill: "#ffffff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxIcon);
export default __webpack_public_path__ + "static/media/CheckboxIcon.bfee769b1f85b5569e943a71618583ac.svg";
export { ForwardRef as ReactComponent };